// Contact.js (Same Website - Internal Link)
import React from "react";
import { motion } from "framer-motion";
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import { Link } from 'react-router-dom'; //  Import Link

function Contact() {
    // Animation Variants
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: { opacity: 1, y: 0 },
    };

    return (
        <section id="contact" className="py-20 md:py-28 px-4 md:px-8 bg-gray-100">
            <div className="container mx-auto">
                <motion.div
                    className="text-center mb-10 md:mb-16"
                    initial="hidden"
                    animate="visible"
                    variants={containerVariants}
                >
                    <motion.h2
                        className="text-4xl md:text-5xl font-bold text-gray-800 mb-4"
                        variants={itemVariants}
                    >
                        Contact Us
                    </motion.h2>
                    <motion.p
                        className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto"
                        variants={itemVariants}
                    >
                        Have questions or need assistance? We're here to help! Reach out to
                        us through any of the following methods:
                    </motion.p>
                </motion.div>

                <motion.div
                    className="flex flex-wrap justify-center gap-8 md:gap-12"
                    variants={containerVariants}
                    initial="hidden"
                    animate="visible"
                >
                    <motion.div
                        className="w-full md:w-1/4 bg-white p-6 md:p-8 rounded-xl shadow-lg flex flex-col items-center"
                        variants={itemVariants}
                        whileHover={{ scale: 1.05 }}
                        transition={{ duration: 0.2 }}
                    >
                        <FaMapMarkerAlt className="text-4xl text-blue-600 mb-4" />
                        <h3 className="text-2xl font-bold text-gray-800 mb-4">Visit Us</h3>
                        <p className="text-gray-600 text-center">
                            First Floor, GR Complex,<br />
                            20 Ramakrishna Road,<br />
                            Salem - 636007, Tamil Nadu, India
                        </p>
                    </motion.div>

                    <motion.div
                        className="w-full md:w-1/4 bg-white p-6 md:p-8 rounded-xl shadow-lg flex flex-col items-center"
                        variants={itemVariants}
                        whileHover={{ scale: 1.05 }}
                        transition={{ duration: 0.2, delay: 0.1 }}
                    >
                        <FaPhoneAlt className="text-4xl text-blue-600 mb-4" />
                        <h3 className="text-2xl font-bold text-gray-800 mb-4">Call Us</h3>
                        <p className="text-gray-600 text-center">
                            <a
                                href="tel:9043588446"
                                className="text-blue-600 hover:underline"
                            >
                                +91 90435 88446
                            </a>
                        </p>
                    </motion.div>

                    <motion.div
                        className="w-full md:w-1/4 bg-white p-6 md:p-8 rounded-xl shadow-lg flex flex-col items-center"
                        variants={itemVariants}
                        whileHover={{ scale: 1.05 }}
                        transition={{ duration: 0.2, delay: 0.2 }}
                    >
                        <FaEnvelope className="text-4xl text-blue-600 mb-4" />
                        <h3 className="text-2xl font-bold text-gray-800 mb-4">Email Us</h3>
                        <p className="text-gray-600 text-center">
                            <a
                                href="mailto:support@kpltd.in"
                                className="text-blue-600 hover:underline"
                            >
                                support@kpltd.in
                            </a>
                        </p>
                    </motion.div>
                </motion.div>

                <div className="text-center mt-10 md:mt-16">
                    {/* Use Link for internal navigation */}
                    <Link
                        to="/callback"  // Relative path to your Callback component
                        className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-8 rounded-full text-lg md:text-xl transition duration-300 ease-in-out shadow-md hover:shadow-lg"
                    >
                        Request a Callback
                    </Link>
                </div>
            </div>
        </section>
    );
}

export default Contact;